export default [
  {
    id: `step-1`,
    title: `Шаг №1`,
    description: `Вы заполняете простую форму, по которой мы поймем для кого Вы планируете сделать подарок`
  },
  {
    id: `step-2`,
    title: `Шаг №2`,
    description: `Сайт автоматически подбирает подарок исходя из Ваших возможностей и потребностей`
  },
  {
    id: `step-3`,
    title: `Шаг №3`,
    description: `Через 5-10 минут Вы точно будете знать что подарить!`
  }
];
